import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Box,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Dashboard3Drawers from '../../dashboard-3-drawers/Dashboard3Drawers';
import SeedAuthenticationRepository from '../../../repository/SeedAuthenticationRepository';
import seedDrawerRoutes from '../../../route/seed-drawer-routes';
import { drawerRoutesPropTypes, dashboard3DrawersIconsPropTypes } from '../../dashboard-3-drawers/d3d-prop-types';
import seedLogo from '../../../images/logo.svg';
import { seedDashboard3DrawersIcons } from '../../../icon/seed-icons';
import MySnackbar from '../../../widgets/MySnackbar';
import pageUtilsPropTypes from '../../page-prop-types';

const SeedMySnackbarPage = (props) => {
  const {
    AuthenticationRepository,
    drawerRoutes,
    applicationName,
    logo,
    icons,
    pageUtils,
  } = props;

  const [open, setOpen] = React.useState(false);
  const [variant, setVariant] = React.useState('success');
  const message = 'MySnackbar';
  const messagePageUtils = 'MySnackbar pageUtils';

  return (
    <Dashboard3Drawers
      titleId="seed.widgets.MySnackbar.title"
      routes={drawerRoutes}
      AuthenticationRepository={AuthenticationRepository}
      applicationName={applicationName}
      logo={logo}
      useBackButton
      icons={icons}
      breadcrumbs={[
        {
          id: 'widgets',
          href: '/widgets',
          titleId: 'seed.widgets.title',
        },
        {
          id: 'detail',
          titleId: 'seed.widgets.MySnackbar.title',
        },
      ]}
    >
      <Box mb={2}>
        <FormControl component="fieldset">
          <FormLabel component="legend">
            <FormattedMessage
              id="seed.widgets.MySnackbar.label.variant"
            />
          </FormLabel>
          <RadioGroup
            aria-label="variant"
            name="variant"
            value={variant}
            onChange={(event) => setVariant(event.target.value)}
          >
            <FormControlLabel
              value="default"
              control={<Radio size="small" color="primary" />}
              label="default"
            />
            <FormControlLabel
              value="success"
              control={<Radio size="small" color="primary" />}
              label="success"
            />
            <FormControlLabel
              value="error"
              control={<Radio size="small" color="primary" />}
              label="error"
            />
            <FormControlLabel
              value="warning"
              control={<Radio size="small" color="primary" />}
              label="warning"
            />
            <FormControlLabel
              value="info"
              control={<Radio size="small" color="primary" />}
              label="info"
            />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box mb={1}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
        >
          Show MySnackbar
        </Button>
      </Box>
      <Box mb={1}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => pageUtils.showSnackbar(messagePageUtils, variant)}
        >
          Show MySnackbar with pageUtils
        </Button>
      </Box>
      <MySnackbar
        open={open}
        onClose={() => setOpen(false)}
        message={message}
        variant={variant}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
      />
    </Dashboard3Drawers>
  );
};

SeedMySnackbarPage.propTypes = {
  AuthenticationRepository: PropTypes.func,
  applicationName: PropTypes.string,
  logo: PropTypes.string,
  drawerRoutes: drawerRoutesPropTypes,
  icons: dashboard3DrawersIconsPropTypes,
  pageUtils: pageUtilsPropTypes.isRequired,
};

SeedMySnackbarPage.defaultProps = {
  AuthenticationRepository: SeedAuthenticationRepository,
  applicationName: 'react-seed',
  logo: seedLogo,
  drawerRoutes: seedDrawerRoutes,
  icons: seedDashboard3DrawersIcons,
};

export default SeedMySnackbarPage;
